import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'vibe_today'

export default function VibeTodayPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's your vibe today?",
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: 'REQUEST_ATT' }),
      )
    }
  }, [])

  return (
    <QuestionPage
      heading={t('pages.onboarding.vibeToday.heading')}
      buttons={[
        {
          text: `🫧 ${t('pages.onboarding.vibeToday.options.softReflective')}`,
          value: 'Soft & reflective I am in my floaty, introspective era',
          subtext: t('pages.onboarding.vibeToday.subtexts.softReflective'),
        },
        {
          text: `🧃 ${t('pages.onboarding.vibeToday.options.playfulOpen')}`,
          value: 'Playful & open Lighthearted with space to explore',
          subtext: t('pages.onboarding.vibeToday.subtexts.playfulOpen'),
        },
        {
          text: `🌀 ${t('pages.onboarding.vibeToday.options.littleChaotic')}`,
          value: 'A little chaotic Like a tab with 43 open thoughts',
          subtext: t('pages.onboarding.vibeToday.subtexts.littleChaotic'),
        },
        {
          text: `🌋 ${t('pages.onboarding.vibeToday.options.readyToTransform')}`,
          value: 'Ready to transform  Let’s go deep, no holding back',
          subtext: t('pages.onboarding.vibeToday.subtexts.readyToTransform'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
